import React from "react";
import NotificationsActiveOutlinedIcon from "@mui/icons-material/NotificationsActiveOutlined";
import { Checkbox, Grid, Tooltip, Typography } from "@mui/material";

import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import SmsIcon from "@mui/icons-material/Sms";
import MarkAsUnreadIcon from "@mui/icons-material/MarkAsUnread";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import MarkAsUnreadOutlinedIcon from "@mui/icons-material/MarkAsUnreadOutlined";

const NotificationChannels = ({
  values,
  handleChange,
  isEdit = false,
  isPatientEnroll = false,
}) => {
  const notificationChannels = [
    {
      title: "Email",
      value: "email",
      disabledForUsers: false,
      activeIcon: <EmailIcon fontSize="medium" sx={{ color: "#94BA33" }} />,
      inactiveIcon: (
        <EmailOutlinedIcon fontSize="medium" sx={{ color: "#757575" }} />
      ),
    },
    {
      title: "Call",
      value: "call",
      disabledForUsers: false,
      activeIcon: <PhoneIcon fontSize="medium" sx={{ color: "#94BA33" }} />,
      inactiveIcon: (
        <PhoneOutlinedIcon fontSize="medium" sx={{ color: "#757575" }} />
      ),
    },
    {
      title: "SMS",
      value: "sms",
      disabledForUsers: false,
      activeIcon: <SmsIcon fontSize="medium" sx={{ color: "#94BA33" }} />,
      inactiveIcon: (
        <SmsOutlinedIcon fontSize="medium" sx={{ color: "#757575" }} />
      ),
    },
    {
      title: "Letter",
      value: "letter",
      disabledForUsers: true, // Letters cannot be deactivated currently
      activeIcon: (
        <MarkAsUnreadIcon fontSize="medium" sx={{ color: "#94BA33" }} />
      ),
      inactiveIcon: (
        <MarkAsUnreadOutlinedIcon fontSize="medium" sx={{ color: "#757575" }} />
      ),
    },
  ];

  return (
    <div>
      <span
        style={{
          fontWeight: 500,
          fontSize: "16px",
          color: !isPatientEnroll && "#175EC8",
        }}
        className="d-flex align-items-center mb-3"
      >
        {!isPatientEnroll && (
          <NotificationsActiveOutlinedIcon fontSize="small" />
        )}
        <span className={!isPatientEnroll ? "ml-2" : ""}>
          Notification Channels
        </span>
      </span>

      <div style={{ display: "flex", gap: "16px" }}>
        {notificationChannels.map((channel) => (
          <div
            key={channel.id || channel}
            style={{
              width: "130px",
              height: isPatientEnroll ? "44px" : "86px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "1px solid #4444445c",
              background: values?.[channel.value] ? "#F1F6E3" : "transparent",
            }}
          >
            <Grid container direction="column" alignItems="center">
              {!isPatientEnroll && (
                <Grid item>
                  {values?.[channel.value]
                    ? channel.activeIcon
                    : channel.inactiveIcon}
                </Grid>
              )}

              <Grid
                item
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "42px",
                }}
              >
                {isEdit && (
                  <Tooltip
                    title={
                      channel.disabledForUsers
                        ? `${channel.title} cannot be deactivated.`
                        : ""
                    }
                    placement="top"
                  >
                    <div
                      style={{
                        cursor: channel.disabledForUsers
                          ? "not-allowed"
                          : "pointer",
                      }}
                    >
                      <Checkbox
                        size="small"
                        checked={values?.[channel.value]}
                        disabled={channel.disabledForUsers}
                        onChange={(e, c) => {
                          handleChange("notification_channels", {
                            ...values,
                            [channel.value]: c,
                          });
                        }}
                        sx={{
                          color: channel.disabledForUsers
                            ? "#BDBDBD"
                            : undefined,
                          "&.Mui-disabled": {
                            color: "#BDBDBD",
                          },
                        }}
                      />
                    </div>
                  </Tooltip>
                )}

                <Typography variant="body1">{channel.title}</Typography>
              </Grid>
            </Grid>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationChannels;
